import { useTranslation } from "react-i18next";
import { Control, Controller } from "react-hook-form";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { InputContainer } from "shared/styles/input-container-style";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { Box } from "@mui/material";

interface Props {
  agreement?: GetExtraWorkAgreementQueryResponse;
  disabled: boolean;
  control: Control<ExtraWorkAgreementFormData>;
}

export const EditExtraWorkAgreementName = (props: Props) => {
  const { t } = useTranslation();

  return (
    <InputContainer>
      <Controller
        name="name"
        control={props.control}
        render={({ field }) =>
          props.disabled ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography variant="body1">{field.value ?? props.agreement?.name}</Typography>
            </Box>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <TextField
                {...field}
                value={field.value ?? ""}
                variant="filled"
                sx={{ width: "auto", minWidth: "50%" }}
                inputProps={{ maxLength: 40 }}
                label={t("dashboard.extraWorkAgreements.create.name.input")}
              />
            </Box>
          )
        }
      />
    </InputContainer>
  );
};
